import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const CameraIcon = {
  name: 'CameraIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 44.1 34.4",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "0.3",
        "stroke-linecap": "round",
        "stroke-miterlimit": "10"
      },
      "class": "feather feather-camera"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M31.243,31.107H5.842c-.448,0-.812-.365-.812-.813v-11.976c0-.448.364-.813.812-.813h25.401c.448,0,.812.365.812.813v11.976c0,.448-.364.813-.812.813ZM5.873,30.263h25.338v-11.914H5.873v11.914ZM31.243,18.349h.002-.002Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M18.587,27.768c-1.909,0-3.462-1.553-3.462-3.462s1.553-3.462,3.462-3.462,3.462,1.553,3.462,3.462-1.553,3.462-3.462,3.462ZM18.587,21.688c-1.444,0-2.618,1.175-2.618,2.618s1.175,2.618,2.618,2.618,2.618-1.175,2.618-2.618-1.175-2.618-2.618-2.618Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M24.922,25.97c-.917,0-1.664-.746-1.664-1.664s.746-1.664,1.664-1.664,1.664.746,1.664,1.664-.746,1.664-1.664,1.664ZM24.922,23.486c-.452,0-.82.368-.82.82s.368.82.82.82.82-.368.82-.82-.368-.82-.82-.82Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M12.257,25.97c-.917,0-1.664-.746-1.664-1.664s.746-1.664,1.664-1.664,1.664.746,1.664,1.664-.746,1.664-1.664,1.664ZM12.257,23.486c-.452,0-.82.368-.82.82s.368.82.82.82.82-.368.82-.82-.368-.82-.82-.82Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M29.206,22.455c-1.542,0-2.797-1.254-2.797-2.796,0-.233.189-.422.422-.422s.422.189.422.422c0,1.077.876,1.953,1.953,1.953.233,0,.422.189.422.422s-.189.422-.422.422Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M26.831,20.081H10.254c-.233,0-.422-.189-.422-.422s.189-.422.422-.422h16.578c.233,0,.422.189.422.422s-.189.422-.422.422Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M27.253,29.375H9.832v-.422c0-1.077-.876-1.953-1.953-1.953h-.422v-4.967c0-.233.189-.422.422-.422s.422.189.422.422v4.155c1.205.183,2.16,1.138,2.343,2.343h15.797c.183-1.205,1.138-2.16,2.343-2.343v-4.155c0-.233.189-.422.422-.422s.422.189.422.422v4.967h-.422c-1.077,0-1.953.876-1.953,1.953v.422Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M7.879,22.455c-.233,0-.422-.189-.422-.422s.189-.422.422-.422c1.077,0,1.953-.876,1.953-1.953,0-.233.189-.422.422-.422s.422.189.422.422c0,1.542-1.255,2.796-2.797,2.796Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M30.858,17.319c-.233,0-.422-.189-.422-.422v-1.021H6.649v.931c0,.233-.189.422-.422.422s-.422-.189-.422-.422v-.985c0-.435.354-.79.789-.79h23.896c.435,0,.789.354.789.79v1.075c0,.233-.189.422-.422.422Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M30.095,14.804c-.233,0-.422-.189-.422-.422v-.394H7.412v.31c0,.233-.189.422-.422.422s-.422-.189-.422-.422v-.387c0-.423.344-.767.766-.767h22.416c.423,0,.766.344.766.767v.471c0,.233-.189.422-.422.422Z"
        }
      }),
      h("path", {
        attrs: {
          d: "M35.315,24.728h0c-.233,0-.422-.189-.422-.422l.002-13.891h3.042l-6.304-6.199-6.304,6.199h3.003v1.647c0,.233-.188.422-.421.422h0c-.233,0-.422-.189-.422-.422v-.803h-2.648c-.263,0-.496-.157-.596-.4-.1-.243-.043-.519.144-.703l6.792-6.68c.249-.245.654-.245.903,0l6.793,6.68c.187.184.244.46.144.703-.099.243-.333.4-.596.4h-2.687l-.002,13.047c0,.233-.189.422-.422.422Z"
        }
      })
    ]);
  }
};

export default CameraIcon;